import * as React from "react";
import { cn } from "./cn";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-10 w-full rounded-card border border-border bg-white px-3 py-2 text-sm text-ink placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50",
        // A field marked aria-invalid outlines itself in the error colour, so
        // every form gets the same look from the one flag it already sets.
        //
        // Border, ring AND a wash of the error colour, not the border alone: a
        // 1px hairline that only changes hue is the same weight as the resting
        // state and reads as no change at all. The ring rather than a thicker
        // border so nothing shifts by a pixel when the field goes invalid.
        "aria-[invalid=true]:border-error aria-[invalid=true]:ring-1 aria-[invalid=true]:ring-error aria-[invalid=true]:bg-error/5",
        "aria-[invalid=true]:focus-visible:ring-2 aria-[invalid=true]:focus-visible:ring-error",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
